import React from 'react';
import AboutMe from '../AboutMe/AboutMe';
import NameSection from '../NameSection/NameSection';
import Navigation from '../../Shared/Navigation/Navigation';
import Services from '../Services/Services';
import Skills from '../Skills/Skills';
import RecentProjects from '../RecentProjects/RecentProjects';
import MyBlog from '../MyBlog/MyBlog';
import Footer from '../../Shared/Footer/Footer';
import Contact from '../Contact/Contact';
import ScrollToTop from '../../../ScrollToTop';

const Home = () => {



    return (
        <>
            <ScrollToTop />
            <Navigation />
            <NameSection />
            <AboutMe />
            <RecentProjects />
            {/* <Skills /> */}
            <Services />
            <MyBlog />
            <Contact />
            <Footer />
        </>
    );
};

export default Home;